// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fS","catalogByServiceItem__title":"c-k_fT"};